import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import font from "src/styles/font";
import device from "src/styles/device";
import { checkNotEmpty, convertPrice } from "src/common";

import { TextField, InputAdornment, Stack, IconButton } from "@mui/material";

import Button from "src/components/core/Button";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const Content = styled.div`
  width: 100%;
  overflow-y: auto;
  flex: 1 1 auto;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--grey-color);
    border-radius: 100px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--grey-color);
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

const Header = styled.div`
  width: 100%;
  padding: 0 24px;
  border-bottom: 10px solid var(--darkwhite-color);
`;

const WrapperHeader = styled.div`
  width: 100%;
  max-width: 530px;
  margin: 0 auto;
`;

const TextLabel = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  color: var(--secondary-color);

  span {
    font-size: ${font.size.md};
    font-weight: 400;
    color: var(--primary-color);
  }

  ${({ groupItem }) =>
    groupItem &&
    css`
      width: 30%;
      flex: 0 0 30%;

      @media ${device.mobileL} {
        width: 28%;
        flex: 0 0 28%;
      }
    `}

  ${({ totalPrice }) =>
    totalPrice &&
    css`
      font-weight: 600;
      text-align: center;
      width: 40%;
      flex: 0 0 40%;

      @media ${device.mobileL} {
        width: 50%;
        flex: 0 0 50%;
      }
    `}
`;

const TextUnit = styled.div`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: var(--darkgrey-color);
  text-align: right;
  width: 30%;
  flex: 0 0 30%;

  @media ${device.mobileL} {
    width: 22%;
    flex: 0 0 22%;
  }
`;

const WrapperTextfield = styled.div`
  /* width: 100%;
  margin: 24px 0; */

  ${({ groupItem }) =>
    groupItem &&
    css`
      width: 40%;
      flex: 0 0 40%;

      @media ${device.mobileL} {
        width: 50%;
        flex: 0 0 50%;
      }
    `}

  .TextField-without-border-radius fieldset {
    border-radius: 24px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 24px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    padding: 16px;
    text-align: center;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 24px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 24px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 24px;
  }
  /* .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0
  } */
`;

const DetailSection = styled.div`
  width: 100%;
  max-width: 578px;
  margin: 0 auto;
  padding: 24px;
`;

const DetailGroup = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;

  :last-child {
    margin-bottom: 0;
  }
`;

const NumberGroup = styled.div`
  display: flex;
  align-items: center;
  width: 40%;
  flex: 0 0 40%;

  .MuiOutlinedInput-root {
    border-radius: 8px;
  }
  .MuiOutlinedInput-input {
    padding: 8px 16px;
    text-align: center;
  }

  @media ${device.mobileL} {
    width: 50%;
    flex: 0 0 50%;
  }
`;

const ButtonGroup = styled(Stack)`
  flex: 0 0 auto;
  width: 100%;
  /* height: max-content; */
  background-color: #fff;
  z-index: 15;
  padding: 32px 24px;
`;

const AddOther = ({
  quoList = [],
  otherData,
  onRemoveElement,
  onSubmit,
  onClose,
  isRemoveDisabled,
}) => {
  const [isEditOther, setIsEditOther] = useState(false);
  const [selectedOtherData, setSelectedOtherdata] = useState({
    other_code: "",
    other_text: "",
    other_unit: "",
    volume: 0,
    price: 0,
    discount: 0,
    total: 0,
    description: "",
  });

  const importProduct = async () => {
    if (quoList[0]?.other_code === "" || quoList[0]?.other_text === "") {
      onRemoveElement(0);
    }

    await onSubmit(selectedOtherData);
    await onClose();
  };

  useEffect(() => {
    if (checkNotEmpty(otherData)) {
      setSelectedOtherdata(otherData);
      setIsEditOther(true);
    }
  }, [otherData]);

  return (
    <>
      <Content>
        <Header>
          <WrapperHeader>
            <TextLabel>
              รายการสินค้าหรือบริการ<span>*</span>
            </TextLabel>

            <WrapperTextfield
              style={{
                width: "100%",
                margin: "16px 0",
              }}
            >
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-input": {
                    textAlign: "left",
                  },
                }}
                placeholder="รหัสสินค้าหรือการบริการ"
                value={selectedOtherData?.other_code}
                onChange={(e) => {
                  setSelectedOtherdata((prev) => ({
                    ...prev,
                    other_code: e.target.value,
                  }));
                }}
                error={selectedOtherData?.other_code === ""}
              />
            </WrapperTextfield>

            <WrapperTextfield
              style={{
                width: "100%",
                marginBottom: "24px",
              }}
            >
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-input": {
                    textAlign: "left",
                  },
                }}
                placeholder="ชื่อสินค้าหรือการบริการ"
                value={selectedOtherData?.other_text}
                onChange={(e) => {
                  setSelectedOtherdata((prev) => ({
                    ...prev,
                    other_text: e.target.value,
                  }));
                }}
                error={selectedOtherData?.other_text === ""}
              />
            </WrapperTextfield>
          </WrapperHeader>
        </Header>

        <DetailSection>
          <DetailGroup>
            <TextLabel groupItem>ราคา</TextLabel>

            <WrapperTextfield groupItem>
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-root": {
                    pl: 0,
                  },
                  ".MuiInputAdornment-root": {
                    position: "absolute",
                    left: "14px",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">฿</InputAdornment>
                  ),
                }}
                value={selectedOtherData?.price}
                onChange={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedOtherdata((prev) => ({
                      ...prev,
                      price: e.target.value,
                      total:
                        +e.target.value * +selectedOtherData.volume -
                        +selectedOtherData.discount,
                    }));
                }}
                onBlur={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedOtherdata((prev) => ({
                      ...prev,
                      price: parseFloat(e.target.value) || 0,
                      total:
                        +e.target.value * +selectedOtherData.volume -
                        +selectedOtherData.discount,
                    }));
                }}
                error={selectedOtherData?.price <= 0}
              />
            </WrapperTextfield>

            <TextUnit>
              {selectedOtherData?.other_unit !== ""
                ? getLocale() === "th"
                  ? `บาท / ${selectedOtherData?.other_unit}`
                  : `Baht / ${selectedOtherData?.other_unit}`
                : getLocale() === "th"
                  ? `บาท / หน่วย`
                  : `Baht / unit`}
            </TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>หน่วย</TextLabel>

            <WrapperTextfield groupItem>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="หน่วย"
                value={selectedOtherData?.other_unit}
                onChange={(e) => {
                  setSelectedOtherdata((prev) => ({
                    ...prev,
                    other_unit: e.target.value,
                  }));
                }}
                error={selectedOtherData?.other_unit === ""}
              />
            </WrapperTextfield>

            <TextUnit></TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>จำนวน</TextLabel>

            <NumberGroup>
              <IconButton
                sx={{
                  p: 0.75,
                  borderRadius: 2.5,
                  border: "1px solid var(--lightgrey-color)",
                }}
                disabled={selectedOtherData?.volume < 1}
                onClick={() => {
                  setSelectedOtherdata((prev) => ({
                    ...prev,
                    volume: +prev.volume - 1,
                    total:
                      +selectedOtherData.price * (+prev.volume - 1) -
                      +selectedOtherData.discount,
                  }));
                }}
              >
                <RemoveIcon sx={{ color: "var(--darkgreen-color)" }} />
              </IconButton>

              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  mx: 2,
                }}
                value={selectedOtherData?.volume}
                onChange={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedOtherdata((prev) => ({
                      ...prev,
                      volume: +e.target.value,
                      total:
                        +selectedOtherData.price * +e.target.value -
                        +selectedOtherData.discount,
                    }));
                }}
                error={selectedOtherData?.volume <= 0}
              />

              <IconButton
                sx={{
                  p: 0.75,
                  borderRadius: 2.5,
                  border: "1px solid var(--lightgrey-color)",
                }}
                onClick={() => {
                  setSelectedOtherdata((prev) => ({
                    ...prev,
                    volume: +prev.volume + 1,
                    total:
                      +selectedOtherData.price * (+prev.volume + 1) -
                      +selectedOtherData.discount,
                  }));
                }}
              >
                <AddIcon sx={{ color: "var(--darkgreen-color)" }} />
              </IconButton>
            </NumberGroup>

            <TextUnit>
              {selectedOtherData?.other_unit !== ""
                ? `${selectedOtherData?.other_unit}`
                : getLocale() === "th"
                  ? `หน่วย`
                  : `unit`}
            </TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>ส่วนลด</TextLabel>

            <WrapperTextfield groupItem>
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-root": {
                    pl: 0,
                  },
                  ".MuiInputAdornment-root": {
                    position: "absolute",
                    left: "14px",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">฿</InputAdornment>
                  ),
                }}
                value={selectedOtherData?.discount}
                onChange={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedOtherdata((prev) => ({
                      ...prev,
                      discount: e.target.value,
                      total:
                        +selectedOtherData.price * +selectedOtherData.volume -
                        +e.target.value,
                    }));
                }}
                onBlur={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedOtherdata((prev) => ({
                      ...prev,
                      discount: parseFloat(e.target.value) || 0,
                      total:
                        +selectedOtherData.price * +selectedOtherData.volume -
                        +e.target.value,
                    }));
                }}
              />
            </WrapperTextfield>

            <TextUnit>บาท</TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>รวมเงิน</TextLabel>

            <TextLabel totalPrice>
              {convertPrice(selectedOtherData?.total)}
            </TextLabel>

            <TextUnit>บาท</TextUnit>
          </DetailGroup>
        </DetailSection>
      </Content>

      <ButtonGroup justifyContent={"center"} alignItems={"center"}>
        <Button
          variant="contained"
          size="large"
          disabled={
            // selectedOtherData?.other_code === productData?.other_code ||
            // selectedOtherData?.other_text === productData?.other_text ||
            // selectedOtherData?.other_unit === productData?.other_unit ||
            selectedOtherData?.other_code === "" ||
            selectedOtherData?.other_text === "" ||
            selectedOtherData?.other_unit === "" ||
            selectedOtherData?.volume === 0 ||
            selectedOtherData?.price === 0
          }
          onClick={() => importProduct()}
          sx={{
            width: "100%",
            maxWidth: 350,
            borderRadius: 4,
            py: 1.5,
          }}
        >
          {isEditOther ? `Confirm` : `Next`}
        </Button>

        {isEditOther ? (
          <Button
            variant="contained"
            size="large"
            disabled={isRemoveDisabled}
            onClick={() => onRemoveElement()}
            sx={{
              width: "100%",
              maxWidth: 350,
              borderRadius: 4,
              py: 1.5,
              mt: 2,
              // boxShadow: "none",
              "&.MuiButton-contained": {
                backgroundColor: "#F7CECB",
                color: "var(--primary-color)",
              },
            }}
          >
            {`Delete`}
          </Button>
        ) : null}
      </ButtonGroup>
    </>
  );
};

export default AddOther;
